module.exports = __webpack_public_path__ + "img/banner_x_3.37e8ed3a.png";